import { Route } from "react-router";
import React from "react";
import { ProtectedRoute } from "./components";
import { RolesListPage } from "@/pages";
import { permissionsRolesReadonly, permissionsRolesFull } from "@/utils";
import { ModulesList } from "@/components";

export const roleRoutes = (parentPath: string): React.ReactElement[] => [
  <Route
    key="roles"
    path=""
    element={
      <ProtectedRoute
        element={<RolesListPage parentPath={parentPath} showPermissions />}
        codes={permissionsRolesReadonly}
      />
    }
  />,

  <Route
    key="roles-permissions-key"
    path="permissions/:key"
    element={
      <ProtectedRoute
        element={<ModulesList parentPath={parentPath} />}
        codes={permissionsRolesFull}
      />
    }
  />,
];
